export default "__VITE_ASSET__76d0c494__"